<template>
  <div id="app">
    <div class="wrapper">
      <header class="header">
        <a href="/"> <img src="./assets/images/logo.svg" alt="" /> </a>
      </header>
      <section class="main">
        <div class="container">
          <div class="main__ttl">Almost there, just a few simple questions</div>
          <div class="main__steps" :style="{ marginLeft: marginLeft }">
            <div class="main__progress" :style="{ width: `${width}%` }"></div>
            <ul>
              <li
                v-for="question in questions"
                :key="question.id"
                :class="{
                  prev: currentQuestionId - 1 === question.id,
                  active: currentQuestionId === question.id,
                  next: currentQuestionId + 1 === question.id
                }"
              ></li>
            </ul>
          </div>
          <div class="main__box">
            <component
              :is="questionComponent"
              :question="currentQuestion"
              :answers="answers"
              @next="next"
              @back="back"
            ></component>
          </div>
        </div>
      </section>
    </div>
    <Modal ref="modal"></Modal>
  </div>
</template>

<script>
import QuestionTemplate from "./components/QuestionTemplate";
import MapTemplate from "./components/MapTemplate";
import MailTemplate from "./components/MailTemplate";
import NameTemplate from "./components/NameTemplate";
import Modal from "./components/Modal";
import axios from "axios";
import questions from "./questions";
import TextQuestion from "./components/TextQuestion";
import Final from "./components/Final";
import Ranking from "./components/Ranking";

export default {
  name: "App",
  components: {
    QuestionTemplate,
    MapTemplate,
    MailTemplate,
    NameTemplate,
    Modal,
    TextQuestion,
    Final,
    Ranking
  },
  data() {
    return {
      answers: {},
      currentQuestionId: 1,
      questions: questions,
      windowWidth: 0
    };
  },
  mounted() {
    this.setWindowWidth();
    window.addEventListener("resize", this.setWindowWidth, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setWindowWidth);
  },
  computed: {
    marginLeft() {
      if (this.windowWidth > 767) {
        return "0px";
      }
      const step = 420 / (this.questions.length - 1);
      return `calc(50% + ${210 - step * (this.currentQuestionId - 1)}px)`;
    },
    questionComponent() {
      switch (this.currentQuestion.type) {
        case "email":
          return MailTemplate;
        case "name":
          return NameTemplate;
        case "map":
          return MapTemplate;
        case "textArea":
          return TextQuestion;
        case "final":
          return Final;
        case "ranking":
          return Ranking;
        default:
          return QuestionTemplate;
      }
    },
    currentQuestion() {
      return this.questions.find(
        question => question.id === this.currentQuestionId
      );
    },
    width() {
      const step = 100 / this.questions.length;
      return this.currentQuestionId * step - step / 2;
    }
  },
  watch: {
    currentQuestionId(val) {
      if (val === this.questions.length) {
        const data = {};
        const formData = new FormData();
        for (const key in this.answers) {
          const element = this.answers[key];
          data[element.ttl] = element.val;
          formData.append(element.ttl.replace(/\s/g, "+"), element.val);
        }
        const integromat = axios.post(
          "https://hook.integromat.com/swyu5axyl05o2pimj3b8omc84wg5xe2q",
          data
        );
        const email = axios.post("order2.php", formData);
        Promise.all([integromat, email])
          .then(() => {})
          .catch(() => {});
      }
    }
  },
  methods: {
    setWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    back() {
      if (this.currentQuestionId > 1) {
        this.currentQuestionId -= 1;
      }
    },
    next(answer) {
      this.answers[answer.id] = {
        val: answer.val,
        ttl: answer.ttl
      };
      this.currentQuestionId += 1;
    }
  }
};
</script>
